module.exports = __webpack_public_path__ + "static/media/report2.5994972d.png";